import { useLocation, useNavigate } from "react-router-dom";
import styles from "./WeeklyInspection.module.css";
import { MdStars, MdCheckCircle, MdClear, MdCheck, MdClose } from "react-icons/md";
import plusIcon from "../../assets/plusIcon.png";
import { AntdInput, AntdSubmit } from "../../components";
import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import WeeklyInspectionMiddleware from "../../store/Middlewares/WeeklyInspectionMiddleware";
import AlertAction from "../../store/Actions/AlertActions";
import moment from "moment";
import { AiOutlineCheckCircle } from "react-icons/ai";
import TextArea from "antd/es/input/TextArea";


const WeeklyInspection = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const data = state?.reportData;
  console.log("data", data);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    getLanguage();
  }, [])

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  console.log('first', data);

  const [CommentModalVisible, setCommentModalVisible] = useState(false);
  const [comment, setComment] = useState('')
  const [ReceptionAreaList, setReceptionAreaList] = useState([
    {
      id: '1',
      standards: 'Exceeds Standards',
      area: 'Floors Vacuumed',
      done: false,
    },
    { id: '2', standards: 'Meets Standards', area: 'Floors Mopped', done: true },
    { id: '3', standards: 'Meets Standards', area: 'Floors Mopped', done: true },
  ]);

  const handleApi = () => {
    if (!comment) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: "Please Add Comment" }))
    }
    else {
      let userData = {
        id: data?.id,
        comment: comment,
      }
      dispatch(WeeklyInspectionMiddleware.contractorComment(userData))
        .then((data) => {
          // Alert.alert('Note', data?.message, [
          //   { text: 'OK', onPress: () => navigation.goBack() },
          // ]);
          
          dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
          setIsModalOpen(false)
          navigate(-1)

        })
        .catch((e) => {
          console.log(e);
        })
    }
  }

  const handleSendButton = () => {
    let userData = {
      id: data?.id
    }
    dispatch(WeeklyInspectionMiddleware.sendToClients(userData))
      .then((data) => {
        // Alert.alert('Note', data?.message, [
        //   { text: 'OK', onPress: () => navigation.goBack() },
        // ]);
        dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
        navigate(-1)
      })
      .catch((e) => {
        console.log(e);
      })

  }


  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  return (
    <div className={styles.WeeklyInspection__mainCon}>
      <div className={styles.WeeklyInspection__heading}>
        <h1>{t("Weekly Inspection")}</h1>
      </div>
      <div className={styles.WeeklyInspection__subCon}>
        <div className={styles.WeeklyInspection__subConLeft}>
          <div className={styles.WeeklyInspection__previousData}>
            <span>{t("Date")}</span>
            <p>{moment(data?.date).format('MM-DD-YYYY')}</p>
          </div>
          <div className={styles.WeeklyInspection__previousData}>
            <span>{t("Location")}</span>
            <p>{data?.location?.address}</p>
          </div>
          <div className={styles.WeeklyInspection__previousData}>
            <span>{t("Time")}</span>
            <p>{moment('01 jan 1947 ' + data?.time).format('hh:mm A')}</p>
          </div>
          <div className={styles.WeeklyInspection__previousData}>
            <span>{t("Inspected By")}</span>
            <p>{data?.cleaner_name}</p>
          </div>
        </div>
        <div className={styles.WeeklyInspection__subConRight}>
          <div className={styles.WeeklyInspection__subConRightH1}>
            <h1>{t("Task Checklist")}</h1>
          </div>
          <div className={styles.WeeklyInspection__taskCL}>
            {data?.checklist?.map((item, index) => {
              console.log('item', item)
              return (
                <>
                  <div className={styles.WeeklyInspection__taskCLdiv}>
                    <div className={styles.WeeklyInspection__iconDiv}>
                      {
                        item?.remarks == 'exceed_standard' ? <MdStars
                          className={styles.WeeklyInspection__icon}
                          color={"#f6921e"}
                        />
                          :
                          item?.remarks == 'meet_standard' ? <MdCheckCircle
                            className={styles.WeeklyInspection__icon}
                            color={"green"}
                          />
                            :
                            item?.remarks == 'below_standard' ? <AiOutlineCheckCircle
                              className={styles.WeeklyInspection__icon}
                              color={"red"}
                            /> : null
                      }

                    </div>
                    <div className={styles.WeeklyInspection__txt}>
                      <span>{item?.remarks == 'exceed_standard' ? `${t("Exceed Standard")}`
                        :
                        item?.remarks == 'meet_standard' ? `${t("Meet Standard")}`
                          :
                          item?.remarks == 'below_standard' ? `${t("Below Standard")}` : null}</span>
                      <p>{item?.name}</p>
                    </div>
                  </div>
                  {/* <div className={styles.WeeklyInspection__taskCLdiv}>
                    <div className={styles.WeeklyInspection__iconDiv}>
                      <MdCheckCircle
                        className={styles.WeeklyInspection__icon}
                        color={"#56F71E"}
                      />
                    </div>
                    <div className={styles.WeeklyInspection__txt}>
                      <span>{t("Task Checklist")}</span>
                      <p>Regular Cleaning</p>
                    </div>
                  </div> */}
                </>
              )
            })}

            <div className={styles.WeeklyInspection__taskCLdiv}>
              <div className={styles.WeeklyInspection__iconDiv}>
                {/* <MdStars className={styles.WeeklyInspection__icon} color={'#f6921e'}/> */}
              </div>
              <div className={styles.WeeklyInspection__txt}>
                <span>{t("Comments")}</span>
                <p>{data?.contractor_comment}</p>
              </div>
              {!data?.contractor_comment ?
              <div className={styles.WeeklyInspection__img}>
                <img src={plusIcon} onClick={showModal} />
              </div>
              : null}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.WeeklyInspection__btnDiv}>
        <div className={styles.WeeklyInspection__btnDivLeft}>
          <MdCheckCircle
            className={styles.WeeklyInspection__icon}
            color={"#56F71E"}
          />
          <span>{t("Completed")}</span>
        </div>
        <div className={styles.WeeklyInspection__btnDivRight}>
          <div className={styles.WeeklyInspection__iconDiv}></div>
          <div className={styles.WeeklyInspection__btn}>
            <AntdSubmit
              text={t("Send To Customers")}
              buttonStyle={{ margin: "15px 0px", height: "50px" }}
              onClick={handleSendButton}
            />
          </div>
        </div>
      </div>
      <Modal
        className="modalStyle"
        style={{
          border: "2px solid #f6921e",
          backgroundColor: "#0F0F0F",
          borderRadius: "10px",
        }}
        closable={false}
        footer={null}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={700}
      >
        <div style={{ display: "flex", justifyContent: "right" }} >
          <MdClear style={{ cursor: "pointer" }} color="#ffffff" size={25} onClick={handleCancel} />
        </div>dfgdfg
        <div className={styles.modal_content}>
          <h1>Add Comment</h1>

          <TextArea
              rows={4}
              style={{ border: '2px solid white', backgroundColor: 'transparent',resize:'none' }}
              onChange={(e) => setComment(e.target.value)} className={styles.input} name={'add_comment'} placeholder={'Enter Your Comment'} label='Add Comment' rules={[{ require: true, type: 'text', message: 'Please enter valid comment' }]}
            />
          {/* <AntdInput onChange={(e) => setComment(e.target.value)} className={styles.antdInput} name={'add_comment'} placeholder={'Enter Your Comment'} label='Add Comment' rules={[{ require: true, type: 'text', message: 'Please enter valid comment' }]} /> */}
          <AntdSubmit
          onClick={handleApi}
            text={"Add Comment"}
            buttonStyle={{ margin: "15px 0px", height: "50px" }}
          />
        </div>
      </Modal>
    </div>
  );
};
export default WeeklyInspection;
